export const contactsData = {
    email: 'madanlal.pk@gmail.com',
    phone: '+92 347 3836151',
    address: 'Karachi, Sindh, Pakistan.',

    sheetAPI: ''
}